module.exports = __webpack_public_path__ + "img/itx-file-type-jpeg.c0ebadcc.svg";